module.exports = __webpack_public_path__ + "img/Grafic (3).16d78e7b.jpg";